'use client';

import { c as _c } from "react/compiler-runtime";
import type { transformCreditCardsMultiCompareEntities } from '@cc-shopping/structured-content-renderer/hydration/CreditCardsMultiCompare/transform';
import { Box } from '@mui/system';
import type { ReactNode } from 'react';
import { useRef } from 'react';
import { HorizontalScrollIndicator } from './HorizontalScrollIndicator';
import { CreditCardsMultiCompareProvider } from './provider';
export const CreditCardsMultiCompareClient = t0 => {
  const $ = _c(11);
  const {
    marketplaceEntities,
    disableMonetization,
    children
  } = t0;
  const containerRef = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      height: "100%",
      overflowX: "auto",
      position: "relative",
      display: "flex"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      display: "inline-flex",
      flexDirection: "column"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children) {
    t3 = <Box sx={t2}>{children}</Box>;
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <HorizontalScrollIndicator />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3) {
    t5 = <Box mb={6} ref={containerRef} sx={t1}>{t3}{t4}</Box>;
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== disableMonetization || $[8] !== marketplaceEntities || $[9] !== t5) {
    t6 = <CreditCardsMultiCompareProvider containerRef={containerRef} offers={marketplaceEntities} disableMonetization={disableMonetization}>{t5}</CreditCardsMultiCompareProvider>;
    $[7] = disableMonetization;
    $[8] = marketplaceEntities;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};